import axios from '@axios';

const base = '/api/v1/kiosk-items';

export default {
  updateKioskSettings(prisonId, updatedSettings){
    return axios.post('/api/v1/prisons/update', updatedSettings);
  },
  getKioskItems(){
    return axios.get(`${base}/`);
  },
  getKioskItem(itemId){
    return axios.get(`${base}/single-item/${itemId}`);
  },
  disableKioskItem(prisonId, itemId){
    return axios.patch(`${base}/disable/${prisonId}/${itemId}`, {});
  },
  createKioskItem(prisonId, item){
    return axios.post(`${base}/create/${prisonId}`, item);
  },
  updateKioskItem(prisonId, itemId, updatedItem){
    return axios.post(`${base}/update/${prisonId}/${itemId}`, updatedItem);
  }
};
